<template>
    <div class="body">
        <div class="back" @click="$router.go(-1)">
            <img src="../../assets/img/i19.png" />
            返回
        </div>
        <div class="content">
            <div class="c_left">
                <div class="cl_title">新建题目</div>
                <div class="cl_box">
                    <div class="clb_item">
                        <div class="lbi_left"><span>*</span>学科</div>
                        <div class="lbi_right">
                            <div class="one">
                                <el-select class="o_item" v-model="subjectId" placeholder="请选择" disabled>
                                    <el-option v-for="item in subjectArr" :key="item.id" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="clb_item">
                        <div class="lbi_left"><span>*</span>难度</div>
                        <div class="lbi_right">
                            <div class="two">
                                <el-radio-group v-model="addData.difficultyLevel">
                                    <el-radio :label="1">简单</el-radio>
                                    <el-radio :label="2">中等</el-radio>
                                    <el-radio :label="3">困难</el-radio>
                                </el-radio-group>
                            </div>
                        </div>
                    </div>
                    <div class="clb_item">
                        <div class="lbi_left"><span>*</span>题目类型</div>
                        <div class="lbi_right">
                            <div class="two">
                                <el-radio-group v-model="addData.type" @change="typeChange">
                                    <el-radio :label="1">单选</el-radio>
                                    <el-radio :label="2">多选</el-radio>
                                    <el-radio :label="3">判断</el-radio>
                                    <el-radio :label="4">主观</el-radio>
                                </el-radio-group>
                            </div>
                        </div>
                    </div>
                    <div class="clb_item">
                        <div class="lbi_left">题目图片</div>
                        <div class="lbi_right">
                            <el-upload style="text-align: left;" :headers="myHeaders"
                                :http-request="handleUploadImgForm" :on-change="imgSaveToUrl" :show-file-list="false"
                                action class="upload-demo" accept="image/*">
                                <img class="three"
                                    :src="addData.questionImg ? webImg + addData.questionImg : require('@/assets/img/sc.png')" />
                            </el-upload>
                        </div>
                    </div>
                    <div class="clb_item" style="width: 100%;">
                        <div class="lbi_left"><span>*</span>题目内容</div>
                        <div class="lbi_right">
                            <el-input class="four" type="textarea" :rows="4" placeholder="请输入内容"
                                v-model="addData.questionContent"></el-input>
                        </div>
                    </div>
                    <div class="clb_item" style="width: 100%;" v-if="addData.type == 4">
                        <div class="lbi_left"><span>*</span>答案解析</div>
                        <div class="lbi_right">
                            <el-input class="four" type="textarea" :rows="4" placeholder="请输入内容"
                                v-model="addData.questionAnalyse"></el-input>
                        </div>
                    </div>
                </div>
                <div class="clb_select" v-if="addData.type != 4">
                    <div class="lbs_left"><span>*</span>题目选项</div>
                    <div class="lbs_right">
                        <!--  v-loading="loading" :span-method="mergeCells" -->
                        <el-table :header-cell-style="{ background: '#F7F8FA' }" :data="addData.techClassQuestionOpt"
                            border style="width: 100%;" :height="'100%'">
                            <el-table-column prop="optionNo" label="选项" width="90">
                                <!-- <template slot-scope="scope">
                                    <el-input v-model="scope.row.optionNo"></el-input>
                                </template> -->
                            </el-table-column>
                            <el-table-column prop="optionContent" label="选项内容">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.optionContent"
                                        v-if="addData.type == 1 || addData.type == 2"></el-input>
                                    <div v-if="addData.type == 3">{{ scope.row.optionContent }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="optionImg" label="选项图片" width="120">
                                <template slot-scope="scope">
                                    <el-upload style="text-align: left;" :headers="myHeaders"
                                        :http-request="(uploadRequest) => handleUploadImgForm1(uploadRequest, scope.row)"
                                        :on-change="imgSaveToUrl" :show-file-list="false" action class="upload-demo"
                                        accept="image/*">
                                        <img style="width: 50px;height: 50px;"
                                            :src="scope.row.optionImg ? webImg + scope.row.optionImg : require('@/assets/img/sc.png')" />
                                    </el-upload>
                                </template>
                            </el-table-column>
                            <el-table-column prop="optionAnswer" label="是否正确" width="80">
                                <template slot-scope="scope">
                                    <el-switch v-model="scope.row.optionAnswer" active-color="#13ce66"
                                        inactive-color="#ff4949" :active-value="1" :inactive-value="2"
                                        @change="val => handleSwitchChange(val, scope.row)"></el-switch>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="80">
                                <template slot-scope="scope">
                                    <div class="btn" style="color: red;cursor: pointer;user-select: none;"
                                        @click="deleteOption(scope.$index)">删除</div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <el-button style="width: 100px;margin-left: 100px;margin-top: 10px;" type="primary" @click="btn_openAdd"
                    v-if="addData.type != 4">添加选项</el-button>
                <div class="cl_bottom">
                    <el-button @click="btn_pre">预览</el-button>
                    <el-button type="primary" @click="submit">提交</el-button>
                </div>
            </div>
            <div class="c_right">
                <div class="cr_title">题目预览</div>
                <div class="chat" v-if="isPre">
                    <div class="ch_bottom">
                        <div class="chb_item">
                            <div class="chb_left">
                                <div class="hbl_right">
                                    <div class="blr_top">
                                        <div v-html="markedt(preprocessLaTeX(addData.questionContent))"></div>
                                        <img v-if="addData.questionImg" :src="webImg + addData.questionImg" style="max-width: 100%; margin-bottom: 10px;" alt="题目图片">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="o_bottom1" v-if="addData.type != 4">
                        <div class="select_list">
                            <el-tag class="sl_item" v-for="(item, index) in addData.techClassQuestionOpt"
                                :key="index">{{
                                    item.optionNo }}</el-tag>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {
    detailQuestionGroup,
    sectionSubject,
    userInfo,
    addQuestion,
    ossToken,
    editQuestion
} from '@/apis/index'
import MarkdownIt from 'markdown-it'
import '@/assets/katex/dist/katex.min.css';
import markdownItKatex from '@iktakahiro/markdown-it-katex';

const markdownRender = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
    breaks: true
});
markdownRender.use(markdownItKatex);
export default {
    data() {
        return {
            myHeaders: { "X-Token": ossToken() },
            id: this.$route.query.id,
            info: {},
            sectionArr: [],
            sectionId: '',
            subjectArr: [],
            subjectId: '',
            addData: {
                questionGroupId: this.$route.query.id,
                difficultyLevel: 1,//难度等级 1-简单 2-中等 3-困难
                type: 1,//题目类型 1-单选 2-多选 3-判断 4-主观
                questionContent: '',//题目内容
                questionAnalyse: '',//答案解析
                questionImg: '',//题目图片 ,隔开
                sectionId: '',
                subjectId: '',
                techClassQuestionOpt: [],//选项
            },
            optionItem: {
                id: '',//id:选项id,修改时必传
                optionAnswer: 2,//是否是正确答案 [1-正确 2-不正确]
                optionContent: '',//选项内容
                optionImg: '',//选项图片
                optionNo: '',//选项号
                questionId: '',//题目id,修改时必传
            },//选项模板
            isPre: false
        }
    },
    mounted() {
        if (this.id) {
            this.getInfo()
        }
        if (this.$route.query.item) {
            const obj = JSON.parse(this.$route.query.item);
            console.log(obj, 'obj');

            this.addData = obj
            // {
            //     questionGroupId: obj.questionGroupId || this.$route.query.id || '',
            //     difficultyLevel: obj.difficultyLevel || 1,
            //     type: obj.type || 1,
            //     questionContent: obj.questionContent || '',
            //     questionAnalyse: obj.questionAnalyse || '',
            //     questionImg: obj.questionImg || '',
            //     sectionId: obj.sectionId || '',
            //     subjectId: obj.subjectId || '',
            //     techClassQuestionOpt: obj.techClassQuestionOpt ? [...obj.techClassQuestionOpt] : [],
            // };
        }
    },
    methods: {
        typeChange(val) {
            console.log(val, 'val');
            this.addData.questionContent = '';
            this.addData.questionAnalyse = '';
            this.addData.questionImg = '';
            this.addData.techClassQuestionOpt = [];
            if (val == 3) {
                this.addData.techClassQuestionOpt = [
                    { ...this.optionItem, optionNo: 'A', optionContent: '正确', optionAnswer: 2 },
                    { ...this.optionItem, optionNo: 'B', optionContent: '错误', optionAnswer: 2 }
                ];
            }
        },

        btn_pre() {
            // 1. 校验题目内容是否为空
            if (!this.addData.questionContent || !this.addData.questionContent.trim()) {
                this.$message.warning('请输入题目内容');
                return;
            }

            // 2. 如果题目类型不是主观题（4），则校验选项
            if (this.addData.type != 4) {
                if (!this.addData.techClassQuestionOpt || this.addData.techClassQuestionOpt.length == 0) {
                    this.$message.warning('请添加题目选项');
                    return;
                }

                // 3. 校验每个选项的选项号和内容是否为空
                for (let i = 0; i < this.addData.techClassQuestionOpt.length; i++) {
                    const opt = this.addData.techClassQuestionOpt[i];
                    if (!opt.optionNo || !opt.optionNo.trim()) {
                        this.$message.warning(`第${i + 1}个选项的选项号不能为空`);
                        return;
                    }
                    if (!opt.optionContent || !opt.optionContent.trim()) {
                        this.$message.warning(`第${i + 1}个选项的选项内容不能为空`);
                        return;
                    }
                }

                // 4. 校验是否至少有一个选项是正确答案
                const hasCorrect = this.addData.techClassQuestionOpt.some(opt => opt.optionAnswer == 1);
                if (!hasCorrect) {
                    this.$message.warning('请至少选择一个正确答案');
                    return;
                }
            }
            this.isPre = true
        },
        markedt(markdown) {
            if (markdown) {
                return markdownRender.render(markdown);
            }
            return '';
        },
        handleSwitchChange(val, currentRow) {
            console.log(val, 'val');

            if (this.addData.type == 2) {
                // 不限制，直接返回
                return;
            }

            if (val == 1) {
                // 当前开关被打开，关闭其他所有开关
                this.addData.techClassQuestionOpt.forEach(row => {
                    if (row != currentRow && row.optionAnswer == 1) {
                        row.optionAnswer = 2;
                    }
                });
            }
            // 如果关闭当前开关（val === 2），不做额外处理，允许全部关闭
        },
        handleUploadImgForm1(param, row) {
            console.log(param, 'imgup', row);
            const formData = new FormData();
            formData.append("multipart", param.file);
            let loading = this.$loading({
                lock: true,
                text: "上传中，请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            // 获取上传token
            ossToken(param.file.name).then(res => {
                let ossRes = JSON.parse(res.data);
                console.log(ossRes, 'getOssToken')
                const ossData = new FormData();
                Object.keys(ossRes).forEach((key) => {
                    ossData.append(key, ossRes[key]);
                });
                console.log(param.file, 'param.file')
                ossData.append("file", param.file);
                var url = ossRes.host;
                axios({
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    method: 'post',
                    url: url,
                    data: ossData
                }).then(async (res2) => {
                    console.log(res2, 'getOssToken axios')
                    row.optionImg = res2.data.url
                    loading.close();
                })
            })
        },
        handleUploadImgForm(param) {
            console.log(param, 'imgup');
            const formData = new FormData();
            formData.append("multipart", param.file);
            let loading = this.$loading({
                lock: true,
                text: "上传中，请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            // 获取上传token
            ossToken(param.file.name).then(res => {
                let ossRes = JSON.parse(res.data);
                console.log(ossRes, 'getOssToken')
                const ossData = new FormData();
                Object.keys(ossRes).forEach((key) => {
                    ossData.append(key, ossRes[key]);
                });
                console.log(param.file, 'param.file')
                ossData.append("file", param.file);
                var url = ossRes.host;
                axios({
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    method: 'post',
                    url: url,
                    data: ossData
                }).then(async (res2) => {
                    console.log(res2, 'getOssToken axios')
                    this.addData.questionImg = res2.data.url
                    console.log(this.addData.questionImg, 'icon');
                    loading.close();
                })
            })
        },
        // 选取图片后自动回调，里面可以获取到文件
        imgSaveToUrl(event) {
            console.log(event, 'eventOnchange');
        },
        add_optionItem() {
            this.addData.techClassQuestionOpt.push(this.optionItem)
            this.dialogVisible = false
        },
        // 删除选项并重新编号
        deleteOption(index) {
            this.addData.techClassQuestionOpt.splice(index, 1);
            this.addData.techClassQuestionOpt.forEach((item, idx) => {
                item.optionNo = String.fromCharCode(65 + idx);
            });
        },

        // 添加选项时自动编号
        btn_openAdd() {
            if (this.addData.type == 3) {
                // 判断题，自动创建两个选项：正确和错误
                this.addData.techClassQuestionOpt = [
                    { ...this.optionItem, optionNo: 'A', optionContent: '正确', optionAnswer: 2 },
                    { ...this.optionItem, optionNo: 'B', optionContent: '错误', optionAnswer: 2 }
                ];
            } else {
                if (this.addData.techClassQuestionOpt.length < 4) {
                    const currentLength = this.addData.techClassQuestionOpt.length;
                    const optionNo = String.fromCharCode(65 + currentLength);
                    this.addData.techClassQuestionOpt.push({ ...this.optionItem, optionNo });
                }
            }
        },
        // btn_openAdd() {
        //     this.addData.techClassQuestionOpt.push({ ...this.optionItem })
        // },
        submit() {
            // 1. 校验题目内容是否为空
            if (!this.addData.questionContent || !this.addData.questionContent.trim()) {
                this.$message.warning('请输入题目内容');
                return;
            }

            // 2. 如果题目类型不是主观题（4），则校验选项
            if (this.addData.type != 4) {
                if (!this.addData.techClassQuestionOpt || this.addData.techClassQuestionOpt.length == 0) {
                    this.$message.warning('请添加题目选项');
                    return;
                }

                // 3. 校验每个选项的选项号和内容是否为空
                for (let i = 0; i < this.addData.techClassQuestionOpt.length; i++) {
                    const opt = this.addData.techClassQuestionOpt[i];
                    if (!opt.optionNo || !opt.optionNo.trim()) {
                        this.$message.warning(`第${i + 1}个选项的选项号不能为空`);
                        return;
                    }
                    if (!opt.optionContent || !opt.optionContent.trim()) {
                        this.$message.warning(`第${i + 1}个选项的选项内容不能为空`);
                        return;
                    }
                }

                // 4. 校验是否至少有一个选项是正确答案
                const hasCorrect = this.addData.techClassQuestionOpt.some(opt => opt.optionAnswer == 1);
                if (!hasCorrect) {
                    this.$message.warning('请至少选择一个正确答案');
                    return;
                }
            } else {
                if (this.addData.questionAnalyse.trim() == '') {
                    this.$message.warning('主观题必须填写答案解析');
                    return;
                }
            }
            if (this.$route.query.item) {
                editQuestion(this.addData).then(res => {
                    console.log(res, 'editQuestion');
                    this.$message.success('修改成功')
                    this.$router.go(-1)
                })
            } else {
                addQuestion(this.addData).then(res => {
                    console.log(res, 'addQuestion');
                    this.$confirm('添加成功，是否继续新增题目？', '提示', {
                        confirmButtonText: '继续新增',
                        cancelButtonText: '返回上一级',
                        type: 'success'
                    }).then(() => {
                        // 用户选择继续新增，清空表单
                        this.addData.questionContent = '';
                        this.addData.questionAnalyse = '';
                        this.addData.questionImg = '';
                        this.addData.techClassQuestionOpt = [];
                        this.isPre = false;
                        // 如果有其他字段需要重置，也一并重置
                    }).catch(() => {
                        // 用户选择返回上一级
                        this.$router.go(-1);
                    });
                })
            }
        },
        getSectionSubject() {
            sectionSubject(2).then(res => {
                console.log(res, 'sectionSubject');
                userInfo().then(resA => {
                    console.log(resA, 'userInfo')
                    this.sectionArr = res.data
                    this.sectionId = this.info.sectionId
                    this.subjectId = this.info.subjectId
                    this.subjectArr = []
                    this.subjectArr = this.sectionArr.find(item => item.id == this.sectionId).subjectList
                })
            })
        },
        getInfo() {
            detailQuestionGroup(this.id).then(res => {
                console.log(res, 'detailQuestionGroup');
                this.info = res.data
                this.addData.sectionId = this.info.sectionId
                this.addData.subjectId = this.info.subjectId
                this.getSectionSubject()
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.pop {
    width: 100%;

    .p_item {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .pi_left {
            width: 60px;
        }

        .pi_right {
            flex: 1;
            margin-left: 20px;
        }
    }
}

.body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .back {
        width: 100%;
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 14px;
        color: #000000;
        // margin-bottom: 10px;
        margin-top: 10px;
        cursor: pointer;
        box-sizing: border-box;
        padding: 0 20px;

        img {
            width: 14px;
            height: 14px;

        }
    }

    .content {
        width: 100%;
        height: 0;
        flex: 1;
        background-color: #fff;
        border-radius: 10px 10px 0 0;
        box-sizing: border-box;
        padding: 10px 20px;
        // padding-top: 0;
        display: flex;
        align-items: flex-start;
        margin-top: 10px;

        .c_left {
            height: 100%;
            flex: 1;
            display: flex;
            flex-direction: column;

            .cl_bottom {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 20px;

                button {
                    width: 150px;
                    height: 40px;
                    margin: 0 20px;
                }
            }

            .cl_title {
                font-weight: bold;
                font-size: 24px;
                color: #252525;
                margin-bottom: 20px;
            }

            .clb_select {
                width: 100%;
                height: 0;
                flex: 1;
                display: flex;
                // align-items: center;

                .lbs_left {
                    width: 100px;
                    font-weight: bold;
                    font-size: 16px;
                    color: #252525;

                    span {
                        font-weight: 500;
                        font-size: 16px;
                        color: #FF0000;
                    }
                }

                .lbs_right {
                    flex: 1;
                    height: 100%;
                    margin-right: 40px;
                }
            }

            .cl_box {
                width: 100%;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                justify-content: space-between;



                .clb_item {
                    width: 45%;
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;

                    .lbi_left {
                        width: 100px;
                        font-weight: bold;
                        font-size: 16px;
                        color: #252525;

                        span {
                            font-weight: 500;
                            font-size: 16px;
                            color: #FF0000;
                        }
                    }

                    .lbi_right {
                        flex: 1;
                        margin-right: 40px;

                        .four {
                            width: 100%;
                            font-size: 14px;
                            font-weight: 500;
                        }

                        .one {
                            width: 100%;
                            height: 40px;

                            .o_item {
                                width: 100%;
                                height: 100%;
                            }

                            // background: #F4F4F4;
                            // border-radius: 2px 2px 2px 2px;
                            // border: 1px solid #E2E6ED;
                            // text-align: left;
                            // line-height: 40px;
                            // font-weight: bold;
                            // font-size: 14px;
                            // color: #252525;
                            // box-sizing: border-box;
                            // padding: 0 20px;
                            // user-select: none;
                        }

                        .two {
                            width: 100%;
                        }

                        .three {
                            width: 50px;
                            height: 50px;
                        }
                    }
                }
            }
        }

        .c_right {
            width: 30%;
            height: 100%;
            display: flex;
            flex-direction: column;
            border-left: 1px solid#EAEAEA;

            .cr_title {
                width: 100%;
                text-align: left;
                font-weight: bold;
                font-size: 20px;
                color: #000000;
                box-sizing: border-box;
                padding: 0 20px;
            }

            .chat {
                width: 100%;
                height: 0;
                flex: 1;
                box-sizing: border-box;
                // padding: 0 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
                // margin-bottom: 10px;
                border-radius: 0 0 8px 8px;

                .ch_bottom::-webkit-scrollbar {
                    display: none;
                }

                .ch_bottom {
                    width: 100%;
                    height: 0;
                    flex: 1;
                    overflow-y: scroll;
                    margin-bottom: 15px;
                    box-sizing: border-box;
                    padding-bottom: 25px;

                    .chb_item {
                        width: 100%;
                        margin-top: 20px;

                        .chb_left {
                            width: 100%;
                            display: flex;
                            align-items: flex-start;

                            .hbl_left {
                                width: 44px;
                                height: 44px;
                                border-radius: 4px;
                            }

                            .hbl_right {
                                // flex: 1;
                                margin-left: 20px;
                                width: fit-content;
                                // max-width: 500px;
                                background: #FAFAFA;
                                border-radius: 10px 10px 10px 10px;
                                box-sizing: border-box;
                                padding: 10px;

                                .blr_top {
                                    font-weight: 500;
                                    font-size: 16px;
                                    color: #333333;
                                    line-height: 32px;

                                    .loading-container {
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                        height: 100%;
                                        // margin-top: 30rpx;
                                        box-sizing: border-box;
                                        padding: 10px;
                                        border-radius: 20px;
                                        margin-left: 16px;
                                        user-select: auto;
                                    }

                                    .dot {
                                        width: 10px;
                                        height: 10px;
                                        background-color: #333;
                                        border-radius: 50%;
                                        margin: 0 5px;
                                        animation: blink 1.4s infinite both;
                                        opacity: 0;
                                    }

                                    .dot:nth-child(1) {
                                        animation-delay: 0.2s;
                                    }

                                    .dot:nth-child(2) {
                                        animation-delay: 0.4s;
                                    }

                                    .dot:nth-child(3) {
                                        animation-delay: 0.6s;
                                    }

                                    @keyframes blink {
                                        0% {
                                            opacity: 0;
                                        }

                                        50% {
                                            opacity: 1;
                                        }

                                        100% {
                                            opacity: 0;
                                        }
                                    }
                                }

                                .blr_bottom {
                                    width: 100%;
                                    display: flex;
                                    align-items: center;
                                    border-top: 1px solid#ececec;
                                    margin-top: 10px;
                                    padding-top: 10px;

                                    .lrb_btn {
                                        font-weight: 500;
                                        font-size: 14px;
                                        color: #333333;
                                        margin-right: 30px;
                                        display: flex;
                                        align-items: center;
                                        cursor: pointer;

                                        img {
                                            width: 14px;
                                            height: 14px;
                                            margin-right: 5px;
                                        }
                                    }
                                }
                            }
                        }

                        .chb_right {
                            display: flex;
                            flex-direction: column;
                            // align-items: flex-start;
                            // justify-content: flex-end;


                            .hbr_bottom {
                                display: flex;
                                align-items: center;
                                justify-content: flex-end;

                                .hbr_text {
                                    width: fit-content;
                                    // max-width: 500px;
                                    background: #2992FF;
                                    border-radius: 10px 10px 10px 10px;
                                    font-weight: 500;
                                    font-size: 16px;
                                    color: #FFFFFF;
                                    line-height: 32px;
                                    box-sizing: border-box;
                                    padding: 10px;
                                }

                                .hbr_tx {
                                    width: 44px;
                                    height: 44px;
                                    margin-left: 20px;
                                    border-radius: 4px;
                                }
                            }

                        }
                    }
                }

                .o_bottom1 {
                    width: 100%;
                    min-height: 146px;
                    background: #FFFFFF;
                    border-top: 1px solid #E9EBF2;
                    padding: 20px;
                    box-sizing: border-box;

                    .select_list {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;

                        .sl_item {
                            margin-right: 20px;
                            min-width: 50px;
                            text-align: center;
                            user-select: none;
                            cursor: pointer;
                            font-size: 18px;
                            font-weight: bold;
                            margin-bottom: 20px;
                        }
                    }
                }
            }
        }
    }
}
</style>
